import React from 'react';
import { PSPBenefit } from '../../interfaces/medicine';
import { Tag, TagLabel } from '../UI-CHAKRA/Tag';
import { Avatar } from '@chakra-ui/react';

interface MedicineBenefitsChipProps {
  benefit: PSPBenefit;
  size?: 'sm' | 'md';
}

const sizeStyles = {
  sm: { avatarHeight: '12px', fontSize: '12px', py: '2px', px: '6px', gap: '2px' },
  md: { avatarHeight: '16px', fontSize: '14px', py: '4px', px: '10px', gap: '6px' },
};

export default function MedicineBenefitsChip(props: MedicineBenefitsChipProps) {
  const { benefit, size = 'sm' } = props;
  const styles = sizeStyles[size];

  return (
    <Tag
      variant={'solid'}
      borderRadius={'full'}
      backgroundColor={benefit.CorFundo}
      width={'fit-content'}
      maxWidth={'100%'}
      py={styles.py}
      px={styles.px}
      gap={styles.gap}
      display={'inline-flex'}
      position={'relative'}
      zIndex={0}
      verticalAlign={'middle'}
      overflow={'hidden'}
    >
      <Avatar
        src={benefit.Logo}
        height={styles.avatarHeight}
        width={'auto'}
        bgColor={'inherit'}
        flexShrink={0}
        pointerEvents={'none'}
      />
      <TagLabel fontWeight={500} color={benefit.CorTexto} fontSize={styles.fontSize}>
        {benefit.Nome}
      </TagLabel>
    </Tag>
  );
}
